import { api } from '../../api/api';
import apiError from '../../api/api-error';

// initial state
const state = {
   rec:null
};

// getters
const getters = {
};

// actions
const actions = {
   PERMIT_ZOOM_TO:(context, {permit})=>{
      context.commit('MAP_FLY_TO', {
         center:permit.geom.coordinates,
         zoom:15.5
      });
   },
   PERMIT_HIGHLIGHT:(context, {})=>{
      context.commit('MAP_HIGHLIGHT', {
         sourceLayer: 'parcels',
         featureVal: state.rec.id
      });
   },
   PERMIT_GET:(context, {id})=>{
      return new Promise((resolve, reject)=>{
         api.get('/api/permits/'+ id)
         .then((res)=>{
            context.commit('PERMIT_SET', {rec: res.data});
            resolve();
         })
         .catch((error)=>{
            context.commit('ERROR_MESSAGE_SET',{message:apiError.message('permit',error)});
            reject(apiError.message('permit',error));
         });
      });
   }
};

// mutations
const mutations = {
   PERMIT_SET:(state,{rec})=>{
      state.rec = rec;
   }
};

export default {
   state,
   getters,
   actions,
   mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/permit.js